<template>
    <div>
        <Navbar Title="Quiz"/>
        <div class="container" style="height:100%">
            <div class="card" style="padding:20px;" :key="respond">
                
                <div v-if="!this.data[0]" class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                    <p v-if="data[0]" style="position:absolute;right:-15px;top:-15px;font-size:15px;padding-left:4px" class="right btn-floating btn-large red">{{correct}} / {{amount}} </p>
                
                <div v-if="data[0]" class="center">
                    <div class="row align-items-center">
                    </div>
                        <p class="left col-12" style="font-family: 'Roboto';font-weight:400;margin:10px">Question {{index+1}}</p>
                        <h4 class="text-center col-12" v-html="data[index].question" style="font-family: 'Roboto';font-weight:300;margin-bottom:40px"></h4>

                        <div class="d-grid gap-2 col-md-8 col-lg-4 mx-auto" style="margin-top:15px" v-for="(choice,ind) in data[index].choices" :key="ind">
                            <button :disabled="data[index].answered!=-1" class="btn row btn-outline-primary" type="button"> 
                                <p style="font-family:'Roboto';font-weight:300;margin:0" @click="answer(index,ind)"> 
                                    {{choice.a}} 
                                    <i v-if="data[index].answered!=-1 && data[index].answered==ind && choice.t==0" style="margin:0;color:red" class="material-icons clear right">clear</i>
                                    <i v-if="data[index].answered!=-1 && choice.t==1"   style="margin:0;color:green" class="material-icons done right">done</i>
                                </p>
                                
                            </button>
                        </div>

                    <div style="margin-top:20px">
                        <button class="btn btn-outline-primary"  type="button" :disabled="index==0" style="margin-right:20px" @click="prev">Prev</button>
                        <button class="btn btn-outline-primary" type="button" @click="finish">Finish</button>
                        <button class="btn btn-outline-primary" type="button" :disabled="index==(amount-1)" style="margin-left:20px" @click="next">Next</button>
                    </div>
                </div>

            </div>
        </div>
        

    </div>
</template>

<script>
import axios from 'axios';
import Navbar from '@/components/Navbar'
export default {
    name: 'Quiz-ses',
    props:['amount',"category","difficulty","type"],
    components: {
        Navbar
    },
    data(){
        return{
            data:[],
            respond:0,
            index:0,
            correct:0,
        }
    },
    methods:{
        next(){
            if(this.index<this.amount-1)
                this.index+=1
        },
        prev(){
            if(this.index>0)
                this.index-=1
        },
        answer(index,ch){
            this.data[index].answered=ch

            if(this.data[index].answered==this.data[index].correct_ind)
                this.correct+=1

            if(index==this.amount-1)
            {
                this.finish()        
            }    
                
        },
        finish(){
            var message
            if(this.correct>=(this.amount*0.75))
                message="🎉 Awesome"
            else if (this.correct>=(this.amount*0.33)) {
                message="👍 Well done"
            } else {
                message="😂 Is this the best  you can do"
            }

            if (window.confirm(message+"!!! Your score is " + this.correct +" / " + this.amount +'. Go to Main Menu'))
            {
                this.$router.push({name :'Quiz'})
            }

        }

    },
    created(){
        let link="https://opentdb.com/api.php?amount="+this.amount
            if(this.category!="any")
                link+="&category="+this.category
            if(this.difficulty!="any")
                link+="&difficulty="+this.difficulty
            if(this.type!="any")
                link+="&type="+this.type

            axios.get(link).then(el => {

                el.data.results.forEach(element => {
                        let q = { question: element.question}
                        q.choices=[]
                        element.incorrect_answers.forEach(el=>{
                            q.choices.push({a:el,t:0})
                        })
                        q.choices.push({a:element.correct_answer,t:1})

                        for (var i = q.choices.length - 1; i > 0; i--) {
                            var j = Math.floor(Math.random() * (i + 1));
                            var temp = q.choices[i];
                            q.choices[i] = q.choices[j];
                            q.choices[j] = temp;
                        }
                        for (i = q.choices.length - 1; i >= 0; i--) {
                            if(q.choices[i].t==1)
                                q.correct_ind=i
                        }

                        q.answered=-1

                        this.data.push(q)

                })
            })
    }
}
</script>

<style scoped>


</style>